import { render } from "./404.vue?vue&type=template&id=1e1cc6d9&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import "./404.vue?vue&type=style&index=0&id=1e1cc6d9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1e1cc6d9"

export default script